export default "__VITE_ASSET__32bb4a58__"